import React from 'react';
import { ToggleButton } from '../../ToggleButton';
import { DesignFormUnitViewType } from '../../units/unitFormModel';

type Props = {
  unitIndex: number;
  manifoldIndex: number;
  selectedViewType: DesignFormUnitViewType | null;
  setViewType: (designFormViewType: DesignFormUnitViewType) => void;
};

export const DesignFormUnitViewTypeButtons = ({ unitIndex, manifoldIndex, selectedViewType, setViewType }: Props) => {
  const options: Array<{ viewType: DesignFormUnitViewType; displayText: string }> = [
    { viewType: 'Basic', displayText: 'Basic' },
    { viewType: 'Performance', displayText: 'Performance' },
    { viewType: 'Thermostats', displayText: 'Thermostats' },
    { viewType: 'Cad', displayText: 'CAD' },
    { viewType: 'Other', displayText: 'Other' },
  ];

  return (
    <>
      {options.map(option => (
        <DesignFormManifoldViewTypeButton
          key={option.viewType}
          unitIndex={unitIndex}
          manifoldIndex={manifoldIndex}
          viewType={option.viewType}
          setViewType={setViewType}
          selectedViewType={selectedViewType || 'Basic'}
        >
          {option.displayText}
        </DesignFormManifoldViewTypeButton>
      ))}
    </>
  );
};

type DesignFormManifoldViewTypeButtonProps = {
  unitIndex: number;
  manifoldIndex: number;
  viewType: DesignFormUnitViewType;
  selectedViewType: DesignFormUnitViewType | null;
  setViewType: (designFormViewType: DesignFormUnitViewType) => void;
  children?: React.ReactNode;
};

const DesignFormManifoldViewTypeButton = ({
  unitIndex,
  manifoldIndex,
  viewType,
  selectedViewType,
  setViewType,
  children,
}: DesignFormManifoldViewTypeButtonProps) => (
  <ToggleButton
    onClick={() => setViewType(viewType)}
    $isCurrent={selectedViewType === viewType}
    data-testid={designFormManifoldViewTypeToggleButtonTestId(unitIndex, manifoldIndex, viewType)}
  >
    {children}
  </ToggleButton>
);

export const designFormManifoldViewTypeToggleButtonTestId = (
  unitIndex: number,
  manifoldIndex: number,
  viewType: DesignFormUnitViewType,
) => `unit-${unitIndex}-manifold-${manifoldIndex}-toggle-design-view-${viewType}`;
